import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=b8d649a4&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "./../../../../assets/mobileStyle.css?vue&type=style&index=0&id=b8d649a4&prod&scoped=true&lang=css&"
import style1 from "./Alert.vue?vue&type=style&index=1&id=b8d649a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d649a4",
  null
  
)

export default component.exports